import React from 'react'
import { Redirect } from 'react-router-dom'
import chartsRoute from './views/charts/ChartsRoute'
import dashboardRoutes from './views/DashboardRoutes'
import dragAndDropRoute from './views/Drag&Drop/DragAndDropRoute'
import formsRoutes from './views/forms/FormsRoutes'
import mapRoutes from './views/map/MapRoutes'
import materialRoutes from './views/material-kit/MaterialRoutes'
import utilitiesRoutes from './views/utilities/UtilitiesRoutes'



const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/citymonthstats" />,
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/session/404" />,
    },
]

const routes = [
    ...dashboardRoutes,
    ...redirectRoute,
    ...errorRoute,
    ...dragAndDropRoute,
    ...materialRoutes,
    ...utilitiesRoutes,
    ...chartsRoute,
    ...dragAndDropRoute,
    ...formsRoutes,
    ...mapRoutes,
]

export default routes
